query(
    $filter: MarketGroupFilter
) {
  marketGroups: allMarketGroups(
    orderBy: POSITION_ASC,
    filter: $filter
) {
    nodes {
      marketGroupId
      code
      displayName
      active
      position
      sportId
      operatorId
      createdAt
      createdBy
      marketCodes: marketGroupMarketCodesByMarketGroupId {
        nodes {
          marketCode
        }
      }
    }
  }
}
